import { DEFAULT_WIDGET_ORDER, Widget } from './widgets/constants';

export const getWidgetOrder = (persistedWidgets: Widget[]) => {
  const out = new Array(DEFAULT_WIDGET_ORDER.length).fill({ enabled: false });

  persistedWidgets.forEach((widget) => {
    const widgetOrder = DEFAULT_WIDGET_ORDER.indexOf(widget.widgetKey);
    if (widgetOrder > -1) {
      out[widgetOrder] = widget;
    } else {
      out.push(widget);
    }
  });

  const enabledWidgets = out.filter((o) => o.enabled);

  return enabledWidgets;
}
